"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _tslib = require("tslib");

var _react = _interopRequireWildcard(require("react"));

var _lodash = require("lodash");

var _Box = _interopRequireDefault(require("../../../Layout/Box"));

var _Heading = _interopRequireDefault(require("../../Heading"));

var _Link = _interopRequireDefault(require("../../Link"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var SummaryBox = _react.default.forwardRef(function (_a, ref) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      sx = _a.sx,
      props = (0, _tslib.__rest)(_a, ["variant", "sx"]);
  return _react.default.createElement(_Box.default, (0, _tslib.__assign)({
    sx: (0, _tslib.__assign)((0, _tslib.__assign)({
      backgroundColor: 'highlight',
      p: 4,
      mb: 2
    }, sx), {
      variant: "forms.summary." + variant + ".root"
    }),
    ref: ref
  }, props));
});

var SummaryHeading = function SummaryHeading(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      props = (0, _tslib.__rest)(_a, ["variant"]);
  return _react.default.createElement(_Heading.default, (0, _tslib.__assign)({
    sx: {
      fontSize: 5,
      mb: 2,
      variant: "forms." + variant + ".summary.heading"
    }
  }, props));
};

var ErrorList = function ErrorList(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      props = (0, _tslib.__rest)(_a, ["variant"]);
  return _react.default.createElement(_Box.default, (0, _tslib.__assign)({
    as: "ul",
    sx: {
      listStylePosition: 'inside',
      variant: "forms." + variant + ".summary.errorList"
    }
  }, props));
};

var ErrorItem = function ErrorItem(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      props = (0, _tslib.__rest)(_a, ["variant"]);
  return _react.default.createElement(_Box.default, (0, _tslib.__assign)({
    as: "li",
    sx: {
      mb: 1,
      variant: "forms." + variant + ".summary.errorItem"
    }
  }, props));
};

var ErrorLink = function ErrorLink(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      props = (0, _tslib.__rest)(_a, ["variant"]);
  return _react.default.createElement(_Box.default, (0, _tslib.__assign)({
    as: _Link.default,
    sx: {
      variant: "forms." + variant + ".summary.errorLink"
    }
  }, props));
};

var Summary = function Summary(_a) {
  var errors = _a.errors;
  var summaryRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    summaryRef.current && summaryRef.current.focus();
  }, []);

  var flattenObject = function flattenObject(obj) {
    if (obj === void 0) {
      obj = {};
    }

    var result = {};

    var flatten = function flatten(collection, prefix, suffix) {
      if (prefix === void 0) {
        prefix = '';
      }

      if (suffix === void 0) {
        suffix = '';
      }

      (0, _lodash.forEach)(collection, function (value, key) {
        var path = "" + prefix + key + suffix;

        if ((0, _lodash.isArray)(value)) {
          flatten(value, path + "[", ']');
        } else if ((0, _lodash.isPlainObject)(value)) {
          flatten(value, path + ".");
        } else {
          result[path] = value;
        }
      });
    };

    flatten(obj);
    return result;
  };

  var errorClick = function errorClick(e) {
    e.preventDefault();
    var href = e.target.href;
    var id = href.substring(href.indexOf('#') + 1, href.length);
    document.getElementById(id).focus();
  };

  return _react.default.createElement(SummaryBox, {
    ref: summaryRef,
    role: "group",
    tabIndex: -1,
    "data-test": "summary"
  }, _react.default.createElement(SummaryHeading, null, "There were some problems"), _react.default.createElement(ErrorList, null, (0, _lodash.map)(flattenObject(errors), function (error, key) {
    return _react.default.createElement(ErrorItem, {
      key: key
    }, _react.default.createElement(ErrorLink, {
      as: "a",
      color: "black",
      href: "#" + key,
      onClick: errorClick
    }, error));
  })));
};

Summary.displayName = 'Summary';
var _default = Summary;
exports.default = _default;